import LazyLoad from 'vanilla-lazyload'
const lazyLoadInstance = new LazyLoad({})
